module.exports = __webpack_public_path__ + "static/media/19ESCAP21.7a8d27f3.jpg";